// extracted by mini-css-extract-plugin
export default {"text":"css_text__oVMTz","textWithNote":"css_textWithNote__dNJ4X","note":"css_note__tt3ZI","buttonsRow":"css_buttonsRow__IKQbl","button":"css_button__ite0R"};